import React, { useState } from "react";
import axios from "axios";

import {
    Menu,
    MenuItem,
    ListItemIcon,
    Typography,
    Divider,
    Box,
    IconButton,
} from "@mui/material"; 
import MoveIcon from "@mui/icons-material/DriveFileMoveOutlined";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import ShortcutIcon from "@mui/icons-material/Link";
import CheckIcon from "@mui/icons-material/Check";
import { useUser } from "../../hooks/Authorize";
// import { useTheme } from "@emotion/react";
import { useTheme } from "../../style/theme";


const folderColors = [
    "#8e8cd8", "#57606f", "#48a1d9", "#4a98f7", "#6fcf97", "#219653",
    "#e6a1a1", "#eb5757", "#bb6bd9", "#825c40", "#c0c0c0", "#3b5998",
    "#f4d03f", "#7ed321", "#ff3c00", "#ff69b4", "#6a1b9a", "#00c3ff",
];

const OrganizeMenu = ({ setAnchorEl, anchorElSubMenu, currentMenuClickedItem, setClikkleItems, handleSubMenuClose, handleOpenMoveDialogModal, handleOpenAddToShortcutDialogModal, setShowProcessingSnackbar, setProcessingMessage }) => {
    const [selectedColor, setSelectedColor] = useState(currentMenuClickedItem.color || "#f4d03f"); // Default selected color
    const [isStarred, setIsStarred] = useState(currentMenuClickedItem.isStarred || false); // Default selected color
    const platformUser = JSON.parse(localStorage.getItem("user"));
    const { mode } = useTheme();
    const handleColorClick = async (color) => {
        setSelectedColor(color);
        try {
            const response = await axios.put(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${currentMenuClickedItem._id}`, {
                id: currentMenuClickedItem._id,
                updates: { color: color },
                userId: platformUser._id
            });
            console.log("API Response:", response.data);
            setClikkleItems((prevItems) =>
                prevItems.map((prevItem) =>
                    prevItem._id === currentMenuClickedItem._id ? { ...prevItem, color: color } : prevItem
                )
            );
        } catch (error) {
            console.error("Error updating color:", error);
        }
        handleSubMenuClose()
        setAnchorEl(null)
    };



    const handleAddToStarredClick = async () => {
        setShowProcessingSnackbar(true)
        setProcessingMessage(isStarred ? "Removing from starred" : "Adding to starred")
        try {
            handleSubMenuClose()
            setAnchorEl(null)

            // Call the API to toggle the favorite status
            const response = await axios.put(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${currentMenuClickedItem._id}`, {
                id: currentMenuClickedItem._id,
                isStarred: !currentMenuClickedItem.isStarred,
                userId: platformUser._id
            });

            console.log("API Response:", response.data);
            setIsStarred(!isStarred)

            // Update the items array after the API call is successful
            setClikkleItems((prevItems) =>
                prevItems.map((prevItem) =>
                    prevItem._id === currentMenuClickedItem._id
                        ? { ...prevItem, isStarred: !prevItem.isStarred }
                        : prevItem
                )
            );
        } catch (error) {
            console.error("Error calling API:", error);
        }
        setShowProcessingSnackbar(false)

    };
    return (
        <Menu
            className="submenu-root"
            anchorEl={anchorElSubMenu}
            open={Boolean(anchorElSubMenu)}
            onClose={handleSubMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            PaperProps={{
                sx: {
                    width: "240px",
                    borderRadius: "8px",
                    padding: "8px 0",
                    // boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                    // background: "rgba(31, 31, 31, 1)",
                    // 
                    boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",  
                    background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",
                    mt: -1,
                    ml: `-${20}px`,
                },
            }}
            MenuProps={{
                disableAutoFocusItem: true,
                PopperProps: {
                    modifiers: [
                        {
                            name: "preventOverflow",
                            options: { boundary: "window" },
                        },
                        {
                            name: "flip",
                            enabled: true,
                        },
                        {
                            name: "offset",
                            options: { offset: [0, 0] },
                        },
                    ],
                },
            }}
        >
            {/* Standard Menu Items */}
            <MenuItem sx={{ padding: "10px 12px" }} onClick={handleOpenMoveDialogModal}>
                <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                    <MoveIcon fontSize="small" />
                </ListItemIcon>
                Move
            </MenuItem>
            <MenuItem sx={{ padding: "10px 12px" }} onClick={handleOpenAddToShortcutDialogModal}>
                <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                    <ShortcutIcon fontSize="small" />
                </ListItemIcon>
                Add Shortcut
            </MenuItem>
            <MenuItem sx={{ padding: "10px 12px" }} onClick={handleAddToStarredClick}>
                <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                    <StarBorderIcon fontSize="small" />
                </ListItemIcon>
                {isStarred ? "Remove from starred" : "Add to starred"}
            </MenuItem>

            {currentMenuClickedItem?.type === 'folder' && (
                <>
                    {/* Divider */}
                    <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.2)", my: 1 }} />

                    {/* Folder Color Section */}
                    <Typography sx={{ fontSize: "12px", fontWeight: 500, px: "16px", mb: "4px" }}>
                        Folder Color
                    </Typography>

                    {/* Color Picker Grid */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(6, 1fr)",
                            gap: "8px",
                            padding: "0 16px 8px 16px",
                        }}
                    >
                        {folderColors.map((color) => (
                            <IconButton
                                key={color}
                                onClick={() => handleColorClick(color)}
                                sx={{
                                    width: "24px",
                                    height: "24px",
                                    borderRadius: "50%",
                                    backgroundColor: color,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    transition: "all 0.2s ease-in-out",
                                    "&:hover": {
                                        transform: "scale(1.1)",
                                    },
                                }}
                            >
                                {selectedColor === color && (
                                    <CheckIcon sx={{  fontSize: "16px" }} />
                                )}
                            </IconButton>
                        ))}
                    </Box>
                </>
            )}
        </Menu>
    );
};

export default OrganizeMenu;
